import React, { memo } from 'react';
import { useForm, useField } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FORM_VALUES } from '../../../../../utils/helpers/constants';
import { chipsStyles, OptionsWrapper } from '../styled';
import { Chips } from '../../../../ui/Chips';
import { Typography } from '../../../../ui/Typography';

const repairType = [
  {
    value: 'true',
    name: 'search.form.has_repair',
    id: 'new-ad-form-has-repair'
  },
  {
    value: 'false',
    name: 'search.form.has_no_repair',
    id: 'new-ad-form-no-repair'
  }
];

const ItemFormFieldHeader = styled(Typography)`
  display: inline-block;
  margin-bottom: 10px;
`;

const RepairTypeComponent = () => {
  const { t } = useTranslation();
  const { change } = useForm();
  const { input: repairField } = useField(FORM_VALUES.hasRepair, {
    subscription: { value: true }
  });

  const value = repairField.value?.toString();

  const onClick = (newValue: string) => {
    if (value === newValue) {
      change(FORM_VALUES.hasRepair, undefined);
    } else {
      change(FORM_VALUES.hasRepair, newValue);
    }
  };

  return (
    <div>
      <ItemFormFieldHeader data-cy="item-form-field-header" tag="title_4_new">
        {t('new_search.repair')}
      </ItemFormFieldHeader>

      <OptionsWrapper>
        {repairType.map(repair => (
          <Chips
            text={t(repair.name)}
            value={repair.value}
            type="button"
            hasCustomOnChange
            key={repair.id}
            storedValue={value}
            onClick={() => onClick(repair.value)}
            styles={chipsStyles}
            cypress={repair.id}
            isTextPadding={false}
          />
        ))}
      </OptionsWrapper>
    </div>
  );
};

export const RepairType = memo(RepairTypeComponent);
